export type NodeDragHandleMode = 'self' | 'descendants';

const NODE_DRAG_HANDLE_ATTR = 'data-node-drag-handle';

export function markNodeDragHandle(element: HTMLElement, mode: NodeDragHandleMode = 'self'): void {
  element.setAttribute(NODE_DRAG_HANDLE_ATTR, mode);
}

export function isNodeDragHandleTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  const handle = target.closest<HTMLElement>(`[${NODE_DRAG_HANDLE_ATTR}]`);
  if (!handle) {
    return false;
  }

  const mode = handle.getAttribute(NODE_DRAG_HANDLE_ATTR);
  return mode === 'descendants' || handle === target;
}
